import { Skeleton, Stack, Typography } from "@mui/material";

const PatientDetailsFormSkeleton = () => {
  return (
    <Stack data-testid="loading-patient-details">
      <Typography variant="h6" id="treating-clinic">
        Treating Clinic
      </Typography>
      <Stack
        direction="row"
        key={"treating-clinic"}
        sx={{
          height: 64,
          justifyContent: "flex-start",
          gap: 2,
          alignItems: "center",
        }}
      >
        <Skeleton sx={{ flex: 1 }} variant="rounded" height={48} />
        <Skeleton sx={{ flex: 1 }} variant="rounded" height={48} />
      </Stack>
      <Typography variant="h6" id="patient-details">
        Patient Details
      </Typography>
      <Typography
        variant="body2"
        sx={{
          paddingBottom: 2,
          scrollMarginTop: "18rem",
        }}
      >
        Please ensure the following patient details match exactly with the EMR
        to avoid potential integration issues.
      </Typography>
      {[...Array(3).keys()].map((n) => (
        <Stack
          direction="row"
          key={n}
          sx={{
            height: 64,
            justifyContent: "flex-start",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Skeleton sx={{ flex: 1 }} variant="rounded" height={48} />
          <Skeleton sx={{ flex: 1 }} variant="rounded" height={48} />
        </Stack>
      ))}
    </Stack>
  );
};

export default PatientDetailsFormSkeleton;
